import axios from 'axios';
import {BASEDOMAIN} from '@/constants/allconstants';
import {AuthConfig} from '@/utils/constants/configContants';

export const fetchForms = async (pageNo: number, dataLength: number, sorting: any, filter: any, searchItem: string, callback: any, errorCallback: any) => {
    let url = searchItem
    ? `${BASEDOMAIN}/form/list?offset=${dataLength * pageNo - dataLength}}&limit=${dataLength}&sort=${JSON.stringify(sorting)}&search=${searchItem}`
    : `${BASEDOMAIN}/form/list?offset=${dataLength * pageNo - dataLength}&limit=${dataLength}&sort=${JSON.stringify(sorting)}`;
    if (filter.createdAtStart) {
        url += `&created_on_or_after=${filter.createdAtStart}`;
    }

    if (filter.createdAtEnd) {
        url += `&created_on_or_before=${filter.createdAtEnd}`;
    }

    if (filter.status) {
        url += `&status=${filter.status.value}`;
    }

    if (filter.owner) {
        url += `&owner=${encodeURIComponent(filter.owner)}`;
    }

    await axios.get(url, AuthConfig()).then((response) => {
        callback(response);
    })
    .catch((e) => {
        errorCallback(e);
        console.log(e);
    });
}

export const getFormById = async (id: string, callBack: any, errCallback: any, after = () => {}, get_template = true) => {
    await axios.get(`${BASEDOMAIN}/form/${id}${get_template ? '?get_template=true' : ''}`, AuthConfig()).then((res) => {
        callBack(res.data);
        after();
    }).catch(e => e?.response?.status === 401 ? {} : errCallback(e))
}

export const fetchFormEnvos = async (formId: string, pageNo: number, dataLength: number, sorting: any, filter: any, searchItem: string, callback: any, errorCallback: any) => {
    let url = searchItem
    ? `${BASEDOMAIN}/form/${formId}/envelope?offset=${dataLength * pageNo - dataLength}}&limit=${dataLength}&sort=${JSON.stringify(sorting)}&search=${searchItem}`
    : `${BASEDOMAIN}/form/${formId}/envelope?offset=${dataLength * pageNo - dataLength}&limit=${dataLength}&sort=${JSON.stringify(sorting)}`;
    if (filter.createdAtStart) {
        url += `&created_on_or_after=${filter.createdAtStart}`;
    }

    if (filter.createdAtEnd) {
        url += `&created_on_or_before=${filter.createdAtEnd}`;
    }

    if (filter.status) {
        url += `&status=${filter.status.value}`;
    }

    await axios.get(url, AuthConfig()).then((response) => {
        callback(response);
    })
    .catch((e) => {
        errorCallback(e);
        console.log(e);
    });
}

export const transferFormOwnership = async (formId: string, payload: { user_id?: string; email_address?: string }) => {
    const response = await axios.post(`${BASEDOMAIN}/form/${formId}/transfer-ownership`, payload, AuthConfig());
    return response.data;
};